"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDraftWysiwyg = require("react-draft-wysiwyg");

var _draftJs = require("draft-js");

require("react-draft-wysiwyg/dist/react-draft-wysiwyg.css");

var _draftjsToHtml = _interopRequireDefault(require("draftjs-to-html"));

var _markdownDraftJs = require("markdown-draft-js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * TextEditor
 *
 * The componenent provides rich text editor
 * 
 * Following are the inputs for the component:
 *
 * wrapperClassName : string, class applied around both the editor and the toolbar.
 *
 * editorClassName : string, class applied around the editor
 * 
 * toolbarClassName : string, class applied around the toolbar
 * 
 * wrapperStyle : object, style object applied around both the editor and the toolbar
 *
 * editorStyle : object, style object applied around the editor
 * 
 * toolbarStyle : object, style object applied around the toolbar
 * 
 * onEditorStateChange : function, function to be called when editor state changes,
 * 
 * defaultContent: string,  the html/markdown content to be passed to editor to initialize the editor with. e.g. : '<p>This is default <strong>Content.</strong></p>'
 * 
 * outputType : string, type of content to be return as output, options : 'html/markdown'
 *
 * inputType : string, type of content to be passed as input to initialize the editor, options : 'html/markdown'
 *
 * locale : string, locale code to change the localization of editor, e.g. : en/ko
 *
 * mentions : bool: wheather to enable the mentions functionality in editor or not
 * 
 * mentionData : object, mention's object with data, required to enable the functionality
 * 
 * toolbar : object, object with toolbar options, to override the toolbar 
 *
 * uploadImageCallBack : function, function to be called when image is getting uploaded. if image upload is enabled in editor, then this function is required.
 */
var TextEditor = /*#__PURE__*/function (_Component) {
  _inherits(TextEditor, _Component);

  var _super = _createSuper(TextEditor);

  function TextEditor() {
    var _this;

    _classCallCheck(this, TextEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onEditorStateChange", function (editorState) {
      _this.props.onEditorStateChange(editorState);
    });

    return _this;
  }

  _createClass(TextEditor, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          locale = _this$props.locale,
          mentions = _this$props.mentions,
          mentionData = _this$props.mentionData,
          toolbar = _this$props.toolbar;
      var localeCode = locale ? locale : "en";
      var mensionData = mentions ? mentionData : {};
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactDraftWysiwyg.Editor, {
        wrapperClassName: this.props.wrapperClassName,
        editorClassName: this.props.editorClassName,
        toolbarClassName: this.props.toolbarClassName,
        wrapperStyle: this.props.wrapperStyle,
        editorStyle: this.props.editorStyle,
        toolbarStyle: this.props.toolbarStyle,
        editorState: this.props.editorState,
        onEditorStateChange: this.onEditorStateChange,
        localization: {
          locale: localeCode
        },
        hashtag: {},
        mention: mensionData,
        toolbar: toolbar
      }));
    }
  }]);

  return TextEditor;
}(_react.Component);

var _default = TextEditor;
exports.default = _default;